/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.LogisticsGroupDetailsResponseDto>;
export function request(
  body: defs.basics.LogisticsGroupRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsGroup/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
